module.exports = __webpack_public_path__ + "img/hall4.60eb479d.jpg";